import { render, staticRenderFns } from "./DevelopmentDetails.vue?vue&type=template&id=5cb72ab8&scoped=true&"
import script from "./DevelopmentDetails.vue?vue&type=script&lang=js&"
export * from "./DevelopmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentDetails.vue?vue&type=style&index=0&id=5cb72ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb72ab8",
  null
  
)

export default component.exports